<!--
 * @Description:
 * @Author: cooky
 * @Date: 2021-03-01 09:17:32
 * @LastEditors: cooky
 * @LastEditTime: 2021-05-11 14:32:28
-->
<template>
  <div class="goods-list">
    <!-- {{ isOnSearch }} -->
    <div v-if="list.length === 0 && showEmpty" class="goods-list--empty">
      <span>{{ $t('no_result') }}</span>
    </div>
    <template v-else>
      <div class="goods-item" v-for="goods in list" :key="goods.id">
        <div class="goods-item-img">
          <img v-if="goods.image_url === 4 || goods.image_url === '4'" :src="require(`@/static/assets/ui/pc/props-${$store.getters.lang}.png`)">
          <img v-else :src="goods.tag ? require(`@/static/assets/ui/pc/props-img${goods.tag || ''}.png`) : ''">
        </div>
        <div class="goods-item-info">
          <div class="goods-item-name" v-html="goods.product_name"></div>
          <div class="goods-item-desc" v-if="goods.info">{{ $t("remark") }}：{{ goods.info }}</div>
          <div class="goods-item-desc" v-else>{{ $t(`tab${ goods.tag }_remark`) }}{{ goods.tag !== 2 ? goods.product_name : '' }}{{ $store.getters.lang === 'en_us' ? ' Now':'' }}</div>
          <!-- 钻石和特权卡都是根据名字显示备注 -->
        </div>
        <div class="goods-item-buy">
          <a :class="{disabled: goods.max_purchase && goods.purchased >= goods.max_purchase }" @click="handleToOrder(goods)">{{ goods.max_purchase && goods.purchased >= goods.max_purchase ? $t("limit_max_tip") : $t('money_symbol') + goods.price }}</a>
          <div class="goods-item-limit" v-if="goods.max_purchase">{{ $t("limited_buying") }}:{{ goods.max_purchase - (goods.purchased || 0) }}/{{ goods.max_purchase }}</div>
        </div>
      </div>
    </template>
    <ComfirmOrder :visible.sync="visible" :goods="editInfo" :payload="payload"/>
  </div>
</template>
<script>
import ComfirmOrder from './ComfirmOrder'

export default {
  name: 'GoodsList',
  props: {
    list: {
      type: Array,
      require: true,
      default: Array
    },
    showEmpty: {
      type: Boolean,
      default: false
    },
    payload: {
      type: String,
      default: '2' // 1搜索购买、2主页（快速）购买、3推荐栏购买
    }
  },
  components: { ComfirmOrder },
  data () {
    return {
      visible: false,
      editInfo: {}
    }
  },
  methods: {
    handleToOrder (goods) {
      if (goods.max_purchase && goods.purchased >= goods.max_purchase) {
        this.$tip({
          content: this.$t('limited_max_tip')
        })
        return
      }
      this.editInfo = goods
      this.visible = true
    }
  }
}
</script>
